import { FC } from "react";
import LockOutlineIcon from "@src/lib/icons/18px/lock-outline";
import { cn } from "@src/lib/utils/cn";
import { IMPERSONATION_SOLID } from "./impersonationStyles";

/** The white lock on a 24px mode-colour circle that blocked-change messages lead with. */
export const ImpersonationLockBadge: FC<{ className?: string }> = ({
  className,
}) => (
  <span
    aria-hidden
    className={cn(
      "flex size-6 shrink-0 items-center justify-center rounded-full",
      IMPERSONATION_SOLID,
      className,
    )}
  >
    <LockOutlineIcon className="size-3.5" />
  </span>
);
